import React, { useState } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import Checkout from './Checkout';

// Load Stripe with your publishable key
const stripePromise = loadStripe('your-publishable-key-here');

const CheckoutContainer = (props) => {
  const [clientSecretSettings, setClientSecretSettings] = useState({
    clientSecret: "",
    loading: true,
  });
  
  return (
    <Elements stripe={stripePromise}>
      <Checkout paymentDue={props.paymentDue} checkoutItems={props.checkoutItems} />
    </Elements>
  );
};

export default CheckoutContainer;